import { Box, Button, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { RoleContext } from 'src/context/roleContext';
import { jwtDecode } from 'jwt-decode';
import { ADMIN, SKOLA } from 'src/constants/role';
import { useTranslation } from 'react-i18next';
import Students from '../students';
import { getSchoolInfo } from 'src/api/schoolMetod';
import './index.css';
import SchoolDashboard from './school/index.js';
import AdminDashboard from './admin';
import { API_BASE_URL } from 'src/apiConfig';

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [schoolLogin, setSchoolLogin] = useState(null);
  const { role, userId, setRole, setUserId } = useContext(RoleContext);
  const [numberOfStudent, setNumberOfStudent] = useState('');
  const { t } = useTranslation();

  const getNumberOfStudent = async (id) => {
    try {
      if (id) {
        const response = await axios.get(
          `${API_BASE_URL}/api/students.php?school_id=${id}`
        );
        if (response.data) {
          setNumberOfStudent(response.data);
        }
      }
    } catch (error) {
      console.error(
        'Greška prilikom preuzimanja informacija o broju studenat:',
        error.message
      );
    }
  };

  useEffect(() => {
    const initialize = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          setRole(decodedToken.role);
          setUserId(decodedToken.user_id);
        } catch (error) {
          console.error('Greška prilikom dekodiranja tokena:', error.message);
        }
      }
    };

    initialize();
  }, [setRole, setUserId]);

  useEffect(() => {
    if (role === SKOLA && userId) {
      const idMatch = userId.match(/\d+/);
      if (idMatch) {
        setUserId(idMatch[0]);
        getSchoolInfo(idMatch[0])
          .then((data) => setSchoolLogin(data))
          .catch((error) =>
            console.error(
              'Greška prilikom preuzimanja informacija o školi:',
              error
            )
          );

        getNumberOfStudent(idMatch[0]);
      }
    }
  }, []);

  return (
    <>
      {role === SKOLA ? (
        <SchoolDashboard />
      ) : role === ADMIN ? (
        <AdminDashboard />
      ) : (
        <Box m="20px">
          {/* HEADER */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Button
                sx={{
                  backgroundColor: colors.blueAccent[700],
                  color: colors.grey[100],
                  fontSize: '14px',
                  fontWeight: 'bold',
                  padding: '10px 20px'
                }}
              >
                <DownloadOutlinedIcon sx={{ mr: '10px' }} />
                {t('text.downloadReports')}
              </Button>
            </Box>
          </Box>
          <h1 className="textHomePage">
            {t('text.studentCountMessage', {
              count: numberOfStudent ? numberOfStudent['count'] : 0
            })}
          </h1>
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="140px"
            gap="20px"
          ></Box>
          <Box
            gridColumn="span 4"
            gridRow="span 2"
            backgroundColor={colors.primary[900]}
          >
            {userId && role === SKOLA && (
              <Students schoolId={userId.match(/\d+/)[0]} />
            )}
          </Box>

          {/* GRID & CHARTS */}
          <Box
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="140px"
            gap="20px"
          ></Box>
        </Box>
      )}
    </>
  );
};

export default Dashboard;
